<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    :rules="rules"
    :value="value"
    @input="onInput"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import constants from "../../../helpers/constants";

export default {
  name: "FieldSourcePicker",

  props: ["title", "isRequired", "value", "modelOnly"],

  computed: {
    rules() {
      return this.isRequired
        ? [ui.requiredRule(this.$store.getters.required)]
        : [];
    },
  },

  data() {
    return {
      fields: [],
    };
  },

  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
  },

  mounted() {
    if (this.modelOnly) {
      this.fields = [
        constants.FIELD_SOURCE_PAGE_FIELD,
        constants.FIELD_SOURCE_FIELD,
        constants.FIELD_SOURCE_VARIABLE,
      ];
    } else {
      this.fields = [
        constants.FIELD_SOURCE_PAGE_FIELD,
        constants.FIELD_SOURCE_FIELD,
        constants.FIELD_SOURCE_VARIABLE,
        constants.FIELD_SOURCE_ROW_ID,
        constants.FIELD_SOURCE_ROUTE_PARAM,
        constants.FIELD_SOURCE_VALUE,
      ];
    }
  },
};
</script>